/**
 * Phase 15.4.1 — Theme palettes mirrored from backend share_card_config.py
 *
 * Source of truth: backend `share_card_config.THEMES`. The frontend
 * keeps a fallback copy here so the share modal still renders when the
 * config fetch fails (offline preview, network blip). The backend
 * payload always wins when present.
 */
export const SHARE_CARD_THEMES = {
  default: {
    id: "default", name: "Default",
    tagline: "Luxury black + amber/pink glow (current production look)",
    palette: {
      bg_a: "#0a0512", bg_b: "#100319", bg_c: "#07020d",
      glow_warm: "250,204,21", glow_cool: "168,85,247",
      accent_ribbon: "linear-gradient(90deg,#facc15 0%,#f59e0b 50%,#ec4899 100%)",
      accent_pill:   "linear-gradient(90deg,#ec4899,#f59e0b)",
      text_primary: "#ffffff",
      text_secondary: "#fde68a",
      text_muted: "#fef3c7",
      metric_bg: "linear-gradient(135deg,rgba(250,204,21,0.18) 0%,rgba(236,72,153,0.18) 100%)",
      metric_border: "rgba(250,204,21,0.55)",
      ring_color: "#facc15",
    },
  },
  light: {
    id: "light", name: "Light",
    tagline: "Cream paper · dark text — clean for IG carousels",
    palette: {
      bg_a: "#fefce8", bg_b: "#fef3c7", bg_c: "#fde68a",
      glow_warm: "250,204,21", glow_cool: "236,72,153",
      accent_ribbon: "linear-gradient(90deg,#7c3aed 0%,#ec4899 50%,#f59e0b 100%)",
      accent_pill:   "linear-gradient(90deg,#7c3aed,#ec4899)",
      text_primary: "#0a0512",
      text_secondary: "#7c3aed",
      text_muted: "#475569",
      metric_bg: "linear-gradient(135deg,rgba(124,58,237,0.10) 0%,rgba(236,72,153,0.10) 100%)",
      metric_border: "rgba(124,58,237,0.45)",
      ring_color: "#7c3aed",
    },
  },
  neon: {
    id: "neon", name: "Neon",
    tagline: "Cyan + lime on black — high-energy rave / live look",
    palette: {
      bg_a: "#000000", bg_b: "#020617", bg_c: "#000000",
      glow_warm: "34,211,238", glow_cool: "163,230,53",
      accent_ribbon: "linear-gradient(90deg,#22d3ee 0%,#a3e635 50%,#facc15 100%)",
      accent_pill:   "linear-gradient(90deg,#22d3ee,#a3e635)",
      text_primary: "#ffffff",
      text_secondary: "#a3e635",
      text_muted: "#67e8f9",
      metric_bg: "linear-gradient(135deg,rgba(34,211,238,0.18) 0%,rgba(163,230,53,0.18) 100%)",
      metric_border: "rgba(34,211,238,0.55)",
      ring_color: "#22d3ee",
    },
  },
  mono: {
    id: "mono", name: "Mono",
    tagline: "Greyscale studio — minimal, magazine cover energy",
    palette: {
      bg_a: "#0a0a0a", bg_b: "#171717", bg_c: "#000000",
      glow_warm: "212,212,216", glow_cool: "82,82,91",
      accent_ribbon: "linear-gradient(90deg,#e4e4e7 0%,#a1a1aa 50%,#52525b 100%)",
      accent_pill:   "linear-gradient(90deg,#e4e4e7,#71717a)",
      text_primary: "#ffffff",
      text_secondary: "#e4e4e7",
      text_muted: "#a1a1aa",
      metric_bg: "linear-gradient(135deg,rgba(228,228,231,0.12) 0%,rgba(82,82,91,0.16) 100%)",
      metric_border: "rgba(228,228,231,0.45)",
      ring_color: "#e4e4e7",
    },
  },
};

export const DEFAULT_SHARE_CARD_CONFIG = {
  title_text: "🎖️ Now Featured on RGM Studio",
  tagline_text: "Featured Artist",
  cta_text: "🚀 In Rotation",
  watermark_text: "Promoted by RGM Studio",
  footer_text: "rgmstudio.org",
  theme: "default",
  show_cover: true,
  show_avatar: true,
  show_stats: true,
  show_badges: true,
  show_watermark: true,
  fallback_image_url: null,
};

export const resolveTheme = (themeId) =>
  SHARE_CARD_THEMES[themeId] || SHARE_CARD_THEMES.default;

export const mergeConfig = (cfg) => ({ ...DEFAULT_SHARE_CARD_CONFIG, ...(cfg || {}) });
